<div class="content">
    <div class="row items-push">
        <div class="col-sm-12 text-left">
            <ol class="breadcrumb push-10-t">
                <li><a [routerLink]="['/']">Inicio</a></li>
                <li><span class="link-effect">Documentos</span></li>
            </ol>
        </div>
    </div>
  </div>
  
  <div class="content">
    <div class="block">
      <div class="block-header">
        <h3 class="block-title">Documentos</h3>
    </div>
    
  
  <div class="block-content">
    <div class="form-horizontal">
      <div class="form-group">
        <!-- <label class="col-md-1 control-label">Documento:</label>
        <div class="col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>Documento</mat-label>
              <input matInput type="text" placeholder="Documento" [(ngModel)]="filter.documento" maxlength="40">
            </mat-form-field>                    
        </div> -->
        
        <label class="col-md-2 control-label">Tipo Visita:</label>
        <div class="col-md-4">
          <mat-form-field appearance="outline">
            <mat-label> Seleccione: </mat-label>
            <mat-select matSelect [(ngModel)]="filter.idTipoVisita" name="idTipoVisita" >
              <mat-option 
                *ngFor="let item of listaTipoVisitas; index as i"
                [value]="item.idTipoVisita">{{ item.nombre }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <label class="col-md-2 control-label">Estado:</label>
        <div class="col-md-4">
          <mat-form-field appearance="outline">
            <mat-label>
              Seleccione
            </mat-label>
            <mat-select matSelect [(ngModel)]="filter.idEstado">
              <mat-option *ngFor="let item of listaEstados; index as i;" [value]='item.idParametroDetalle'>{{item.valor}}</mat-option>
            </mat-select>
          </mat-form-field>   
        </div>    
    </div>
  
    <div class="form-horizontal">
      <div class="form-group">
          <div class="col-sm-6 text-left">
            <a class="btn btn-naranja" mat-raised-button [routerLink]="['/configuracion', 'documentos', 'registrar']"><mat-icon>description</mat-icon> Nuevo Documento</a>     
            <!-- [routerLink]="['/solicitudes-engie/registrar']" -->
            <!-- <a class="btn btn-celeste" mat-raised-button [routerLink]="['/solicitudes-engie, 'exportar']">Exportar</a> -->
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" mat-raised-button (click)="search()" ><mat-icon>search</mat-icon> Buscar</a>
          </div>
      </div>
    </div>
    <div class="table-responsive">
      <table mat-table [dataSource]="model.items" class="table table-striped table-vcenter">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>Id</th>
            <td mat-cell *matCellDef="let element">{{ element.idConfiguracionDocumento }}</td>
          </ng-container>
      
          <ng-container matColumnDef="documento">
            <th mat-header-cell *matHeaderCellDef>Documento</th>
            <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
          </ng-container>

          <ng-container matColumnDef="tipoVisita">
            <th mat-header-cell *matHeaderCellDef>Tipo Visita</th>
            <td mat-cell *matCellDef="let element">{{ element.tipoVisita }}</td>
          </ng-container>
          
          <ng-container matColumnDef="seccion">
            <th mat-header-cell *matHeaderCellDef>seccion</th>
            <td mat-cell *matCellDef="let element">{{ element.nombreSeccion }}</td>
          </ng-container>
          
          <ng-container matColumnDef="restringeAccesos">
            <th mat-header-cell *matHeaderCellDef>Restringe Accesos</th>
            <td mat-cell *matCellDef="let element">{{ element.restringeAccesos? 'SI': 'NO' }}</td>
          </ng-container>
          
          <ng-container matColumnDef="idRequisito">
            <th mat-header-cell *matHeaderCellDef>Requisito</th>
            <td mat-cell *matCellDef="let element">{{ element.requisito }}</td>
          </ng-container>
          

          <ng-container matColumnDef="controlarFechas">
            <th mat-header-cell *matHeaderCellDef>Controlar Fechas</th>
            <td mat-cell *matCellDef="let element">{{ element.controlarFechas? 'SI': 'NO' }}</td>
          </ng-container>

          <ng-container matColumnDef="esPredeterminado">
            <th mat-header-cell *matHeaderCellDef>Es Predeterminado</th>
            <td mat-cell *matCellDef="let element">{{ element.esPredeterminado? 'SI': 'NO' }}</td>
          </ng-container>
      
          <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let element"> 
                <a mat-icon-button color="primary" aria-label="Editar" [routerLink]="['/configuracion/', 'documentos', element.idConfiguracionDocumento]">
                  <!-- (click)="openDialog(element)" -->
                  <mat-icon>create</mat-icon>
                </a>
              </td>
            </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      
        </table>  

        <mat-paginator #paginator [length]="resultsLength" [pageSize]="30" 
              (page)="getPaginatorData($event)"
              [pageSizeOptions]="[30, 50, 100]"></mat-paginator>
      </div>
  
    </div>
  </div>
  </div>